import youtubeBreadcrumbSchema from '@seo/schemas/youtubeBreadCrumbSchema';

export const getYoutubeCourseBreadcrumbs = (goal) => [
  {
    title: goal?.name,
    url: `/goal/${goal.slug}/${goal.uid}`
  },
  {
    title: 'Free courses',
    url: `/content/p/freecourses/${goal.uid}`
  }
];

export const getSingleYoutubeCourseBreadcrumbs = (goal) => [
  {
    title: goal?.name,
    url: `/goal/${goal.slug}/${goal.uid}`
  },
  {
    title: 'Free courses',
    url: `/content/p/freecourses/${goal.uid}`
  },
  {
    title: 'Popular classes',
    url: `/content/p/freecourses/${goal.uid}/free-lessons`
  }
];

export const youtubeCourseSchema = ({ goalInfo }) => {
  const breadCrumbs = getSingleYoutubeCourseBreadcrumbs(goalInfo);
  return youtubeBreadcrumbSchema(breadCrumbs);
};

export const convertTitleToSlug = (title) =>
  title
    .trim() // remove whitespaces at the start and end of string
    .toLowerCase()
    .replace(/^-+/g, '') // remove one or more dash at the start of the string
    .replace(/[^\w-]+/g, '-') // convert any on-alphanumeric character to a dash
    .replace(/-+/g, '-') // convert consecutive dashes to singuar one
    .replace(/-+$/g, ''); // remove one or more dash at the end of the string
